// Documentation content for AI Joomla Accessibility Widget.

export const accessibilityWidgetDocs = {
  slug: 'ai-joomla-accessibility-widget',
  name: 'AI Joomla Accessibility Widget',
  tagline: 'Floating ADA & WCAG 2.1 accessibility toolbar for Joomla 4, 5 & 6',
  accent: 'teal',
  sections: [
    {
      id: 'requirements',
      title: 'Requirements',
      body: [
        'AI Joomla Accessibility Widget runs on any server where Joomla itself runs without issues \u2014 there are no unusual server requirements.',
        'Supported: Joomla 4.x, 5.x and 6.x. We recommend keeping Joomla and PHP on a currently-supported version for the best compatibility and security.',
      ],
    },
    {
      id: 'installation',
      title: 'Installation',
      body: [
        'Download the package ZIP from your AI Joomla account after purchase (or from the Free tier download after registering for a key).',
        'Log in to your Joomla administrator panel with a Super User account.',
        'Go to System \u2192 Manage \u2192 Install, click Upload & Install, and select the downloaded ZIP.',
        'Joomla installs two parts together: the Accessibility system plugin (which renders the floating widget) and a placeholder module (which lets you control exactly which pages/positions load it). Both finishing with a green "successfully installed" message means you\u2019re ready to configure it.',
        'Enable the plugin under System \u2192 Manage \u2192 Plugins \u2014 search "Accessibility" and toggle it on.',
      ],
    },
    {
      id: 'quick-start',
      title: 'Quick start',
      body: [
        'Go to Content \u2192 Site Modules \u2192 New, and choose "AI Joomla Accessibility Widget" from the module type list.',
        'Set Status to Published, assign it to a position that renders on every page (or use Menu Assignment to control exactly where it appears), and Save & Close.',
        'View your site \u2014 a floating accessibility button appears in the corner. Click it to open the adjustment panel.',
        'Open the plugin\u2019s Options (System \u2192 Manage \u2192 Plugins \u2192 AI Joomla Accessibility) to choose the button position, panel theme (dark/light), and which adjustment categories are shown to visitors.',
      ],
    },
    {
      id: 'features',
      title: 'What visitors can adjust',
      body: [
        'Text size, line height & letter spacing \u2014 scale content up or down without breaking your layout.',
        'Contrast & color modes \u2014 dark contrast, light contrast, monochrome and saturation adjustments for low-vision visitors.',
        'Dyslexia-friendly font \u2014 one click swaps body text to a more readable typeface, site-wide.',
        'Screen reader / text-to-speech \u2014 reads page content aloud for visually impaired visitors.',
        'Link & heading highlighting \u2014 underline every link or outline every heading so page structure is instantly scannable.',
        'Keyboard navigation \u2014 a visible focus outline and full keyboard-only support for motor-impaired visitors.',
        'Custom quick links \u2014 pin your own accessibility statement, contact page, or sitemap into the widget panel.',
      ],
    },
    {
      id: 'licensing',
      title: 'License tiers & Download ID',
      body: [
        'Every tier \u2014 including Free \u2014 requires a Registration & Download ID key, generated automatically when you create your AI Joomla account.',
        'Paste your Download ID into the extension\u2019s Download Key field under System \u2192 Manage \u2192 Install \u2192 Update, or directly on the plugin/module\u2019s manage screen \u2014 this is what unlocks one-click updates.',
        'Pro tiers add automatic updates and direct support; Lifetime tiers remove the yearly renewal.',
      ],
    },
    {
      id: 'faq',
      title: 'FAQ & troubleshooting',
      body: [
        'Q: Does this make my site 100% ADA compliant? A: No single tool can guarantee full legal compliance on its own \u2014 it depends on your content and markup too. The widget gives visitors the adjustment tools WCAG 2.1 calls for as a strong, visible step toward compliance.',
        'Q: Will it slow my site down? A: No \u2014 assets only load on pages where the module is published, and the panel renders on demand when opened.',
        'Q: Can I customize the button color or position? A: Yes, both are configurable from the plugin\u2019s Options tab.',
        'Q: How do I upgrade to a new version? A: Install the newer ZIP over the top from System \u2192 Manage \u2192 Install, the same way as the first install \u2014 your saved settings are preserved.',
      ],
    },
  ],
};
